export const getVariantStyles = variant => {
  switch (variant) {
    case 'info':
      return {
        backgroundColor: 'alert-background-info',
        borderInlineColor: 'alert-border-info',
        borderBlockColor: 'alert-border-info'
      };
    case 'system-info':
      return {
        backgroundColor: 'alert-background-info-loud'
      };
    case 'warning':
      return {
        backgroundColor: 'alert-background-warning',
        borderInlineColor: 'alert-border-warning',
        borderBlockColor: 'alert-border-warning'
      };
    case 'system-warning':
      return {
        backgroundColor: 'alert-background-warning-loud'
      };
    case 'danger':
      return {
        backgroundColor: 'alert-background-danger',
        borderInlineColor: 'alert-border-danger',
        borderBlockColor: 'alert-border-danger'
      };
    case 'system-danger':
      return {
        backgroundColor: 'alert-background-danger-loud'
      };
    case 'success':
      return {
        backgroundColor: 'alert-background-success',
        borderInlineColor: 'alert-border-success',
        borderBlockColor: 'alert-border-success'
      };
    default:
      {
        const __exhaustiveCheck = variant;
        throw new Error(`Unhandled \`variant\` argument:\n ${variant}`);
      }
  }
};